import { Injectable } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { BehaviorSubject, Observable } from 'rxjs';
import { ContractType } from '../../models';
import { ProgressStateUiService } from './progress-state-ui.service';
import { SwProcessService } from '../data/sw-process.Service';

@Injectable({
  providedIn: 'root'
})
export class SwProcessStateService {
  private swProcessModelSubject: BehaviorSubject<ContractType> = new BehaviorSubject<ContractType>(null);
  public get swProcessModel$(): Observable<ContractType> { return this.swProcessModelSubject.asObservable(); }

  private cSigSubject: BehaviorSubject<string> = new BehaviorSubject<string>(null);
  private isSWSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(null);


  constructor(
    private router: Router,
    private progressStateUiService: ProgressStateUiService,
    private swProcessService: SwProcessService) {
  }

  initSwProcess(): Observable<ContractType> {
    return new Observable((observer) => {

      this.swProcessService.getCjResponseSw().subscribe({
        next: (swProcessData) => {
          this.swProcessModelSubject.next(swProcessData);
          observer.next();
          observer.complete();
        }
      });

    });
  }

  public get isSW$(): Observable<boolean> {
    return this.isSWSubject.asObservable();
  }

  public setisSW(isSW: boolean): void {
    this.isSWSubject.next(isSW);
  }

  public get cSig$(): Observable<string> {
    return this.cSigSubject.asObservable();
  }

  public setCSig(cSig: string): void {
    this.cSigSubject.next(cSig);
  }

  //public updateSwProcessModel<T>(updater: SwProcessUpdater<T>, value: T): void {
  //  var updatedModel = updater(this.swProcessModelSubject.getValue(), value);
  //  this.swProcessModelSubject.next(updatedModel);
  //}

  public submitSwInput(model: ContractType): void {
    this.progressStateUiService.deferProgressUntill(this.swProcessService.postCjResponseSw(model));
    this.redirectToProgress();
  }

  public discardSwInput(): void {
    this.redirectToProgress();
  }

  private redirectToProgress(): void {
    const cSig = this.cSigSubject.value;
    //TODO 1: The below code requires refactoring as the source value below should be fetched from the backend
    // and no business logic should be written on the front-end
    this.router.navigate(['/progress'], {
      queryParamsHandling: 'merge',
      queryParams: {
        source: 'isWaitPageFromSection'
      }
    });
  }  
}
